var map = {
	"./anchorIndustry.svg": "bb05",
	"./asbestos_icon.svg": "107d",
	"./cleaningagents_icon.svg": "375b",
	"./construction_icon.svg": "72f9",
	"./corp_cchst.svg": "d130",
	"./data_tool.svg": "d142",
	"./data_tool_fr.svg": "8862",
	"./data_tool_help.svg": "9e30",
	"./dieselengineexhaust_icon.svg": "91cf",
	"./explore.svg": "6fb7",
	"./flourandgraindust_icon.svg": "67bb",
	"./foodbeverage_icon.svg": "f1f9",
	"./foodbeverage_icon_old.svg": "3326",
	"./healthcare_icon.svg": "8a5c",
	"./icon.fb.svg": "9935",
	"./icon.linkedin.svg": "afa1",
	"./icon.twitter.svg": "7637",
	"./interpret_data_help.svg": "2e6c",
	"./metalmanufacturing_icon.svg": "e504",
	"./mining_icon.svg": "ec14",
	"./nickel_icon.svg": "5c01",
	"./ocrc_logo_fr.svg": "42d5",
	"./odss_title_old.svg": "ce28",
	"./overview.svg": "29b6",
	"./overview_minus.svg": "86ac",
	"./overview_plus.svg": "895a",
	"./plasticproducts_icon.svg": "a285",
	"./polycyclicaromatichydrocarbons_icon.svg": "4c74",
	"./protective_icon.svg": "3b57",
	"./resource_minus.svg": "1942",
	"./resource_plus.svg": "b7e8",
	"./rubberproducts_icon.svg": "0f2d",
	"./sector_minus.svg": "8c0a",
	"./sector_plus.svg": "26bb",
	"./silica_icon.svg": "e1f2",
	"./subgroup_minus.svg": "1ba6",
	"./subgroup_plus.svg": "12e3",
	"./transportation_icon.svg": "1c40",
	"./uvradiation_icon.svg": "e969",
	"./video_play.svg": "7534",
	"./weldingfumes_icon.svg": "6887",
	"./wooddust_icon.svg": "3ed9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";